/**
 * Shared Key Helper for React Query
 * Creates stable, consistent query keys with proper parameter handling
 */

export function stableKey(base, params) {
  if (!params) {
    return [...base];
  }
  const out = {};
  for (const k of Object.keys(params).sort()) {
    let v = params[k];
    if (Array.isArray(v)) {
      const arr = [...new Set(v)].sort();
      v = arr.length ? arr : undefined; // collapse [] -> undefined
    }
    out[k] = v;
  }
  return [...base, out];
}
//# sourceMappingURL=key.js.map